
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartDisplaySettingsIec as ObiChartDisplaySettingsIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-display-settings-iec.js';
 
 
 

 
 export const ObiChartDisplaySettingsIec = createComponent({
   react: React,
   tagName: 'obi-chart-display-settings-iec',
   elementClass: ObiChartDisplaySettingsIecElement,
   events: {
     
   }
  });
 
 